"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _order = require("@/api/order");
var _supplierOrderShipments = require("./supplierOrderShipments");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'SupplierOrderRecordPanel',
  props: {
    orderNo: {
      type: String,
      default: ''
    },
    active: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      loading: false,
      submitLoading: false,
      syncLoading: false,
      records: [],
      invoiceLoadFailed: false,
      loaded: false,
      requestId: 0,
      infoVisible: false,
      infoRecordId: '',
      infoContent: ''
    };
  },
  watch: {
    active: function active(val) {
      if (val && !this.loaded) this.getList();
    },
    orderNo: function orderNo() {
      this.requestId++;
      this.records = [];
      this.invoiceLoadFailed = false;
      this.loaded = false;
      this.loading = false;
      this.submitLoading = false;
      this.syncLoading = false;
      this.infoVisible = false;
      if (this.active) this.getList();
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.requestId++;
  },
  methods: {
    showInfo: function showInfo(row) {
      this.infoRecordId = row.id;
      try {
        this.infoContent = JSON.stringify(typeof row.info === 'string' ? JSON.parse(row.info) : row.info, null, 2);
      } catch (error) {
        this.infoContent = String(row.info);
      }
      this.infoVisible = true;
    },
    getList: function getList() {
      var _this = this;
      if (!this.orderNo) return;
      var requestId = ++this.requestId;
      this.loading = true;
      return Promise.all([(0, _order.getSupplierOrderListApi)(this.orderNo), (0, _order.orderInvoiceListApi)(this.orderNo).catch(function () {
        return null;
      })]).then(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          records = _ref2[0],
          invoices = _ref2[1];
        if (requestId !== _this.requestId) return;
        _this.invoiceLoadFailed = !Array.isArray(invoices);
        _this.records = (Array.isArray(records) ? records : []).map(function (row) {
          return _objectSpread(_objectSpread({}, row), {}, {
            shipments: (0, _supplierOrderShipments.shipmentsForSupplierOrder)(row, invoices)
          });
        });
        _this.loaded = true;
      }).finally(function () {
        if (requestId === _this.requestId) _this.loading = false;
      });
    },
    handleSubmit: function handleSubmit() {
      var _this2 = this;
      if (!this.orderNo) return;
      var orderNo = this.orderNo;
      this.$confirm('确认补偿下单？系统会重新调用开放平台下单链路。', '提示', {
        type: 'warning'
      }).then(function () {
        if (orderNo !== _this2.orderNo) throw new Error('订单已切换');
        _this2.submitLoading = true;
        return (0, _order.submitSupplierOrderApi)(orderNo);
      }).then(function () {
        if (orderNo !== _this2.orderNo) return;
        _this2.$message.success('补偿下单已执行');
        _this2.getList();
      }).catch(function () {}).finally(function () {
        if (orderNo === _this2.orderNo) _this2.submitLoading = false;
      });
    },
    handleSync: function handleSync() {
      var _this3 = this;
      if (!this.orderNo) return;
      var orderNo = this.orderNo;
      this.syncLoading = true;
      (0, _order.querySupplierOrderStatusApi)(orderNo).then(function () {
        if (orderNo !== _this3.orderNo) return;
        _this3.$message.success('同步状态已执行');
        _this3.getList();
      }).finally(function () {
        if (orderNo === _this3.orderNo) _this3.syncLoading = false;
      });
    },
    formatStatus: function formatStatus(status) {
      var map = {
        '-1': '已取消',
        0: '待处理',
        1: '已下单',
        2: '已取消',
        10: '已支付',
        20: '待审核',
        30: '履约中',
        40: '已发货',
        50: '已完成',
        60: '售后/异常中',
        70: '待退货',
        80: '已退货',
        90: '待退款',
        100: '已退款'
      };
      return map[status] || status || '-';
    },
    statusTagType: function statusTagType(status) {
      if ([40, 50, 100].includes(status)) return 'success';
      if ([-1, 2, 60].includes(status)) return 'danger';
      if ([0, 20, 30, 70, 90].includes(status)) return 'warning';
      return 'info';
    },
    formatAfterSalesStatus: function formatAfterSalesStatus(status) {
      var map = {
        '-1': '已取消',
        0: '已申请',
        1: '已发货',
        2: '已完成'
      };
      return map[status] || '未售后';
    }
  }
};